/**
 * @generated SignedSource<<359041a8b304fc865fce2ced4a1e6600>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobsLoaderQuery$variables = {
  hospitalId: string;
  numberOfOperatingRooms: number;
  skip: boolean;
};
export type JobsLoaderQuery$data = {
  readonly hospital?: {
    readonly id: string;
    readonly name: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"SurgeryTimelineFragment">;
  } | null | undefined;
};
export type JobsLoaderQuery = {
  response: JobsLoaderQuery$data;
  variables: JobsLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hospitalId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "numberOfOperatingRooms"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "hospitalId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JobsLoaderQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Hospital",
            "kind": "LinkedField",
            "name": "hospital",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SurgeryTimelineFragment"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JobsLoaderQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Hospital",
            "kind": "LinkedField",
            "name": "hospital",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "numberOfOperatingRooms"
                  }
                ],
                "concreteType": "LocationConnection",
                "kind": "LinkedField",
                "name": "operatingRooms",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LocationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Location",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7f1ed3dbfc9ce115fc4dd3a4e68fe7ed",
    "id": null,
    "metadata": {},
    "name": "JobsLoaderQuery",
    "operationKind": "query",
    "text": "query JobsLoaderQuery(\n  $hospitalId: ID!\n  $numberOfOperatingRooms: Int!\n  $skip: Boolean!\n) {\n  hospital(id: $hospitalId) @skip(if: $skip) {\n    id\n    name\n    ...SurgeryTimelineFragment\n  }\n}\n\nfragment SurgeryTimelineFragment on Hospital {\n  name\n  id\n  operatingRooms(first: $numberOfOperatingRooms) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e246c08c502b8f52b870a641c20462d3";

export default node;
